import { lazy, Suspense } from "react"
import { Routes, Route, Navigate } from "react-router-dom"
import DashboardLayout from "./components/dashboard/dashboard-layout"
import { AdminAuthGuard } from "@/components/admin-auth-guard"
import ClientLayout from "@/components/ClientLayout"

const Dashboard = lazy(() => import("@/pages/dashboard"))
const Analytics = lazy(() => import("@/pages/dashboard/analytics/index"))
const Announcements = lazy(() => import("@/pages/dashboard/announcements"))
const ActiveUsers = lazy(() => import("@/pages/dashboard/active-users"))
const Companies = lazy(() => import("@/pages/dashboard/companies"))
const Coupon = lazy(() => import("@/pages/dashboard/coupon"))
const Data = lazy(() => import("@/pages/dashboard/data"))
const ExamBuilder = lazy(() => import("@/pages/dashboard/exam-builder"))
const InterestManagement = lazy(() => import("@/pages/dashboard/interest-management"))
const Orders = lazy(() => import("@/pages/dashboard/orders"))
const Payments = lazy(() => import("@/pages/dashboard/payments"))
const Plans = lazy(() => import("@/pages/dashboard/plans"))
const ProgressTracker = lazy(() => import("@/pages/dashboard/progress-tracker"))
const FlaggedQuestions = lazy(() => import("@/pages/dashboard/flagged-questions"))
const QuestionBank = lazy(() => import("@/pages/dashboard/question-bank/index"))
const QuestionsAttempted = lazy(() => import("@/pages/dashboard/questions-attempted"))
const QuestionsUploaded = lazy(() => import("@/pages/dashboard/questions-uploaded"))
const SourceManagement = lazy(() => import("@/pages/dashboard/source-management"))
const EmailLogs = lazy(() => import("@/pages/dashboard/email-logs"))
const Subscriptions = lazy(() => import("@/pages/dashboard/subscriptions"))
const Users = lazy(() => import("@/pages/dashboard/users"))
const Login = lazy(() => import("@/pages/login"))

function App() {
  return (
    <Suspense fallback={<div className="flex items-center justify-center min-h-screen text-muted-foreground">Loading...</div>}>
      <Routes>
        <Route element={<ClientLayout />}>
          <Route path="/login" element={<Login />} />

          <Route
            path="/"
            element={
              <AdminAuthGuard>
                <DashboardLayout />
              </AdminAuthGuard>
            }
          >
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="dashboard/active-users" element={<ActiveUsers />} />
            <Route path="dashboard/companies" element={<Companies />} />
            <Route path="dashboard/coupon" element={<Coupon />} />
            <Route path="dashboard/data" element={<Data />} />
            <Route path="dashboard/exam-builder" element={<ExamBuilder />} />
            <Route path="dashboard/announcements" element={<Announcements />} />
            <Route path="dashboard/interest-management" element={<InterestManagement />} />
            <Route path="dashboard/orders" element={<Orders />} />
            <Route path="dashboard/payments" element={<Payments />} />
            <Route path="dashboard/plans" element={<Plans />} />
            <Route path="dashboard/progress-tracker" element={<ProgressTracker />} />
            <Route path="dashboard/flagged-questions" element={<FlaggedQuestions />} />
            <Route path="dashboard/question-bank" element={<QuestionBank />} />
            <Route path="dashboard/questions-attempted" element={<QuestionsAttempted />} />
            <Route path="dashboard/questions-uploaded" element={<QuestionsUploaded />} />
            <Route path="dashboard/source-management" element={<SourceManagement />} />
            <Route path="dashboard/email-logs" element={<EmailLogs />} />
            <Route path="dashboard/subscriptions" element={<Subscriptions />} />
            <Route path="dashboard/users" element={<Users />} />
            <Route path="analytics" element={<Analytics />} />
          </Route>
        </Route>
      </Routes>
    </Suspense>
  )
}

export default App
